export const KNOWLEDGE_MARKDOWN_SAMPLE = [
  '## When to use this guidance',
  '',
  'Use this entry when a recurring line issue needs consistent expert handling.',
  '',
  '## Symptoms',
  '',
  '- Intermittent failures during startup or speed changes',
  '- Defect pattern repeats after an adjustment or tooling change',
  '- Operators can temporarily clear the issue, but it returns',
  '',
  '## Recommended response',
  '',
  '1. Confirm the affected line, machine, and product configuration.',
  '2. Check the latest approved SOP or work instruction before changing settings.',
  '3. Document the observed defect rate, corrective action, and verification result.',
  '',
  '## Notes for experts',
  '',
  '**Escalate immediately** if product quality, release status, or patient safety could be affected.',
  '',
  'Reference useful IDs like `SOP-123`, batch numbers, or equipment IDs when available.',
].join('\n')

export function isOnlyKnowledgeMarkdownSample(value: string) {
  return value.trim() === KNOWLEDGE_MARKDOWN_SAMPLE.trim()
}
